/**
 * Utility functions for notification calculations
 */

/**
 * Counts unique sessions from a list of attendance records
 * @param attendances - Array of attendance records with session_id
 * @returns Number of unique sessions
 */
export function countUniqueSessions(
  attendances: Array<{ session_id: string }> | null | undefined
): number {
  if (!attendances || attendances.length === 0) {
    return 0;
  }

  const uniqueSessionIds = new Set(attendances.map((a) => a.session_id));
  return uniqueSessionIds.size;
}
